import { Component, Input, OnInit, } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-video-repeat-admin-config',
  templateUrl: './video-repeat-admin-config.component.html',
  styleUrls: ['./video-repeat-admin-config.component.scss']
})
export class AtwVideoRepeatAdminConfig implements OnInit {
  @Input() objectChoosing: any;
  @Input() device: any;
  @Input() class: any;
  @Input() config: any;
  @Input() staticdata: any;
  @Input() blocks_of_page: any;
  @Input() type: any;

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  styles_field = [
    {
      title: 'bo_goc',
      index: 1
    },
  ];

  configMode: 'basic' | 'advanced' = 'basic';

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
    public functionService: FunctionService
  ) { }

  ngOnInit(): void {
  }

  /**
  * Hàm này dùng để mở rộng phần cấu hình.
  * @param field_text : trả về phần tử được chọn của mảng style_field
  */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false
  };
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
}
